export default 10;


/** WEBPACK FOOTER **
 ** ./src/api/delay.js
 **/